// src/pages/Reports/JointTours.jsx
import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Toast from '../../components/Toast/Toast';
import './JointTours.css';

const JointTours = () => {
  const { user, isSuperAdmin } = useAuth();

  const [stats, setStats] = useState({
    thisYear: 0,
    thisMonth: 0,
    lastTen: 0,
  });
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    fetchStats();
    fetchEntries();
  }, []);

  const fetchStats = async () => {
    try {
      const companyId = isSuperAdmin 
        ? localStorage.getItem('selectedCompanyId')
        : user?.companyId;

      const token = localStorage.getItem('token');
      const params = companyId ? { companyId } : {};


      const response = await api.get('/joint-tours/stats', { params });

      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const fetchEntries = async () => {
    setLoading(true);
    try {
      const companyId = isSuperAdmin 
        ? localStorage.getItem('selectedCompanyId')
        : user?.companyId;

      const token = localStorage.getItem('token');
      const params = companyId ? { companyId } : {};
      const response = await api.get('/joint-tours/entries', { params });

      if (response.data.success) {
        setEntries(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching entries:', error);
      setToast({ message: 'Failed to fetch joint tours', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="joint-tours-page">
      {/* Toast Notification */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span className="breadcrumb-item">Home</span>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-item active">Dashboard</span>
      </div>

      {/* Stats Cards */}
      <div className="stats-cards-grid">
        {/* This Year Card */}
        <div className="stat-card">
          <div className="stat-card-header">
            <h4 className="stat-card-title">Joint Tours</h4>
            <span className="stat-card-period">| This Year</span>
          </div>
          <div className="stat-card-content">
            <div className="stat-icon-wrapper blue">
              <div className="stat-icon">❤️</div>
            </div>
            <div className="stat-value">{stats.thisYear}</div>
          </div>
        </div>

        {/* This Month Card */}
        <div className="stat-card">
          <div className="stat-card-header">
            <h3 className="stat-card-title">Joint Tours</h3>
            <span className="stat-card-period">| This Month</span>
          </div>
          <div className="stat-card-content">
            <div className="stat-icon-wrapper green">
              <div className="stat-icon">❤️</div>
            </div>
            <div className="stat-value">{stats.thisMonth}</div>
          </div>
        </div>

        {/* Last Ten Card */}
        <div className="stat-card">
          <div className="stat-card-header">
            <h3 className="stat-card-title">Joint Tours</h3>
            <span className="stat-card-period">| Last Ten</span>
          </div>
          <div className="stat-card-content">
            <div className="stat-icon-wrapper purple">
              <div className="stat-icon">❤️</div>
            </div>
            <div className="stat-value">{stats.lastTen}</div>
          </div>
        </div>
      </div>

      {/* Joint Tours Table */}
      <div className="joint-tours-table-section">
        <div className="table-header">
          <h3 className="table-title">Joint Tours</h3>
          <span className="table-period">| This Month</span>
        </div>

        <div className="table-container">
          {loading ? (
            <div className="loading">Loading joint tours...</div>
          ) : (
            <table className="joint-tours-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Joint Tours</th>
                </tr>
              </thead>
              <tbody>
                {entries.length > 0 ? (
                  entries.map((entry, index) => (
                    <tr key={index}>
                      <td>{entry.name}</td>
                      <td>{entry.jointTours}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="no-data">
                      No joint tours this month
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default JointTours;